"use client";

import { CMSData } from "@/cms/models";
import { GetContentComponent } from "@/services/component.service";
import { ApplicationFraction } from "@/utils/gql/graphql";
import { getGap } from "@/utils/theme-helper";

export interface GridComponentProps {
  cmsData: CMSData;
  app: ApplicationFraction;
  items: any[];
  config: {
    cols: string;
    gap: string;
  };
}

const GridComponent: React.FC<{
  config: GridComponentProps;
}> = ({ config }) => {
  if (!config.items || config.items.length === 0) {
    return null;
  }

  return (
    <div
      data-type="GridComponent"
      className={`grid grid-cols-${config.config.cols} ${getGap(config.config.gap)}`}
    >
      {config.items.map((item, index) => {
        const content = GetContentComponent(
          config.cmsData,
          item,
          `grid-content-${index}`,
          index,
          config.app
        );

        return content;
      })}
    </div>
  );
};

export default GridComponent;
